const SortOrder = {
  newestFirst: 'newestFirst',
  oldestFirst: 'oldestFirst',
};

export default SortOrder;
